module.exports = __webpack_public_path__ + "img/facebook-logo.4731331e.png";